<template>
  <div v-if="show" :class="`alert-${type}`" class="alert alert-dismissible fade show">
    {{ message }}
    <button type="button" class="close" @click="close()">
      <span>&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'LayoutNotification',
  data: () => ({
    show: false,
    type: 'danger',
    message: ''
  }),
  created () {
    this.$root.$on('Notification::show', playload => {
      this.show = true
      this.type = playload.type
      this.message = playload.message

      setTimeout(() => {
        this.close()
      }, playload.timeout || 4000)
    })
  },
  methods: {
    close () {
      this.message = ''
      this.type = 'danger'
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.alert {
  position: fixed;
  z-index: 1000;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  max-width: 400px;
}
</style>
